import { Options, Vue } from 'vue-class-component';
import PageHeader from '@/shared/components/page-header/index.vue';
@Options<NoAccess>({
  components:{
    PageHeader
  }
})
export default class NoAccess extends Vue {

}
